export class MsgModel {
  MAX_SESSIONS_ALLOWED?: number;
  MOU_REQUIRED?: boolean;
  MSG?: string;
  OTHER_SESSIONS_ACTIVE?: number;
  PASSWORD_CHANGE_REQUIRED?: boolean;
  ROB_REQUIRED?: boolean;
  SUCCESS?: boolean;
  TOKEN_EXPIRED?: boolean;
}
